export const environment = {
    production: true,
    webrtcSignalingUrl: 'wss://horde-signaling.fly.dev/signaling',
};
